<form [formGroup]="formVisualizar" aria-labelledby="visualizar-chamado-title">
  <breadcrumb
    [paginas]="[{route:'/home',name:'Home'},
    {route:'/#',name:'Visualizar Chamado'},
    {route:'/detalhe/'+ parametroId , name:'Chamado: '+ parametroId}]"
    aria-label="Navegação de breadcrumb"
  />
  <section class="section-saudacao" aria-labelledby="saudacao-title">
    <div class="container">

      <p>
        <b>Olá,</b> {{this.userLogado?.flPsicologo ? "Psicólogo(a)": this.atribuicoesLogin.NomePerfil }}<br />
        <b>{{this.userLogado?.flPsicologo ? this.userLogado?.nome : this.atribuicoesLogin.Nome}}</b>
      </p>

      <app-btn-back></app-btn-back>

    </div>
  </section>

  <section class="conteudo-principal" aria-labelledby="conteudo-title">
    <div class="container-conviva busca-aluno">
      <div class="container-conviva">

        <div class="conteudo-busca-aluno conteudo-chamado page-visualizar-chamado notranslate" translate="no" *ngIf="chamado != null" aria-labelledby="visualizar-chamado-title">

          <!-- Card Principal do Chamado -->
          <div class="card-chamado-principal">
            <div class="card-header">
              <div class="chamado-info-principal">
                <!-- Avatar e Info Básica -->
                <div class="chamado-avatar-section">
                  <div class="avatar-chamado">
                    <span class="avatar-initials-main">{{envolvidos[0]?.iniciais || 'NC'}}</span>
                    <span class="status-indicator-main"></span>
                  </div>
                  <div class="chamado-detalhes-header">
                    <div class="chamado-numero-row">
                      <span class="chamado-numero">Chamado {{chamado.cdChamado}}</span>
                      <span class="chamado-gravidade-tag notranslate" translate="no" *ngIf="chamado.dsGravidade">{{chamado.dsGravidade}}</span>
                    </div>
                    <h1 class="chamado-titulo notranslate" translate="no">{{ getLinhaIdentificadorCabecalho(envolvidos[0]) }}</h1>
                    <p class="chamado-subtitulo notranslate" translate="no">
                      {{chamado.dsEscola}} · {{envolvidos[0]?.dsTipoPessoa || 'Estudante'}}
                    </p>
                    <p class="chamado-meta notranslate" translate="no">
                      {{envolvidos[0]?.dsEnvolvido || 'Ofendido'}} · {{chamado.dsCategoria}}
                    </p>
                  </div>
                </div>

                <!-- Histórico de status e Menu lado a lado -->
                <div class="header-actions-right">
                  <!-- Link direto para histórico de status -->
                  <button 
                    type="button" 
                    class="btn-historico-status"
                    (click)="abrirModalHistoricoStatus()">
                    <i class="icon-historico-status-inline"></i>
                    Histórico de status
                  </button>
                  
                  <!-- Menu de opções -->
                  <div class="chamado-opcoes">
                    <input type="checkbox" class="card-opcoes-chamado" id="opcoes-chamado-01"/>
                    <label for="opcoes-chamado-01">
                      <a class="btn-opcoes"></a>
                      <div class="opcoes-card">
                        <a href="javascript:void(0)"
                            (click)="OnEditarChamado(this.chamado.cdChamado); fecharMenuOpcoes()">
                          Alterar
                        </a>
                        <a href="javascript:void(0)"
                          (click)="abrirModalHistoricoStatus(); fecharMenuOpcoes()">
                          Visualizar
                        </a>
                        <a href="javascript:void(0)"
                          (click)="AbrirModalConcluirChamado(this.chamado.cdChamado); fecharMenuOpcoes()">
                          Concluir
                        </a>
                        <a href="javascript:void(0)"
                          (click)="AbrirModalEncerrarChamado(this.chamado.cdChamado); fecharMenuOpcoes()">
                          Encerra Chamado do Envolvido
                        </a>
                        <a href="javascript:void(0)"
                          *ngIf="podeEncaminhar()"
                          (click)="abrirModalEncaminhar(this.chamado.cdChamado, 0); fecharMenuOpcoes()">
                          Encaminhamento
                        </a>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Grid de Informações -->
            <div class="card-info-grid">
              <div class="card-info-row">
                <span class="info-label-figma">Em aberto</span>
                <span class="info-value-figma">{{chamado.diasAbertura || '-'}} {{chamado.diasAbertura ? 'dias' : ''}}</span>
              </div>
              <div class="card-info-row">
                <span class="info-label-figma">Abertura em</span>
                <span class="info-value-figma">{{chamado.dtAbertura || '-'}}</span>
              </div>
              <div class="card-info-row">
                <span class="info-label-figma">Aconteceu em</span>
                <span class="info-value-figma">{{chamado.dtOcorrencia || '-'}}</span>
              </div>
              <div class="card-info-row">
                <span class="info-label-figma">Status</span>
                <span class="info-value-figma status-text notranslate" translate="no" [ngClass]="{'status-nao-analisado': chamado.status === 0}">{{chamado.statusS || 'Criado'}}</span>
              </div>
            </div>

            <!-- Encaminhamentos (apenas para Estudante) -->
            <div class="encaminhamentos-header" *ngIf="podeEncaminhar()">
              <span class="encaminhamentos-label">Encaminhamentos:</span>
              <div class="encaminhamentos-btns">
                <button 
                  type="button" 
                  class="btn-encaminhamento-icon"
                  *ngIf="this.userLogado?.funcionalidades?.includes(6)"
                  (click)="abrirModalEncaminhar(this.chamado.cdChamado, envolvidos[0]?.cdEnvolvido || 0, 'psicologo')"
                  title="Encaminhar para Psicólogo">
                  <i class="icon-psicologo-header"></i>
                </button>
                <button 
                  type="button" 
                  class="btn-encaminhamento-icon"
                  *ngIf="this.userLogado?.funcionalidades?.includes(7)"
                  (click)="abrirModalEncaminhar(this.chamado.cdChamado, envolvidos[0]?.cdEnvolvido || 0, 'rede-protetiva')"
                  title="Encaminhar para Rede Protetiva">
                  <i class="icon-rede-protetiva-header"></i>
                </button>
                <button 
                  type="button" 
                  class="btn-encaminhamento-icon"
                  *ngIf="this.userLogado?.funcionalidades?.includes(8)"
                  (click)="abrirModalEncaminhar(this.chamado.cdChamado, envolvidos[0]?.cdEnvolvido || 0, 'rede-hospitalar')"
                  title="Encaminhar para Rede Hospitalar">
                  <i class="icon-rede-hospitalar-header"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Seção de Ações -->
          <div class="secao-acoes">
            <h2 class="section-title">Ações</h2>
            <div class="acoes-btns">
              <button 
                *ngIf="podeEncaminhar()"
                type="button"
                (click)="abrirModalEncaminhar(this.chamado.cdChamado, 0)"
                class="btn-acao"
                aria-label="Encaminhar">
                <i class="icon-encaminhar"></i>
                Encaminhar
              </button>
              <a 
                *ngIf="envolvidos.length > 0"
                [routerLink]="['/perfil-aluno/', envolvidos[0]?.codigoAluno]"
                class="btn-acao"
                aria-label="Perfil do envolvido">
                <i class="icon-user"></i>
                Perfil do envolvido
              </a>
              <button 
                *ngIf="envolvidos.length > 0"
                type="button"
                (click)="realizarAgendamento(envolvidos[0])"
                class="btn-acao"
                aria-label="Realizar agendamento">
                <i class="icon-agendamento"></i>
                Realizar agendamento
              </button>
            </div>
          </div>

          <!-- Layout de 2 colunas: Informações + Histórico -->
          <div class="chamado-content-layout">
            <!-- Coluna Esquerda: Sobre o Chamado -->
            <div class="coluna-esquerda">
              <!-- Sobre o Chamado -->
              <div class="sobre-chamado" aria-labelledby="sobre-chamado-title">
                <h2 class="section-title">Sobre o chamado</h2>
                
                <div class="descricao-chamado-container">
                  <h3 class="descricao-label">Descrição</h3>
                  <div class="descricao-conteudo">
                    <p>{{chamado.dsOcorrencia}}</p>
                  </div>
                </div>
              </div>

              <!-- Anexos Adicionados -->
              <div class="anexos-adicionados" *ngIf="chamado.caminhoArquivo && chamado.caminhoArquivo.length > 0">
                <div class="anexos-header">
                  <h3 class="anexos-titulo">Anexos adicionados</h3>
                </div>
            <div class="lista-anexos">
              <div class="anexo-item-figma" *ngFor="let caminho of chamado.caminhoArquivo; let i = index">
                <div class="anexo-info-figma">
                  <i class="icon-file-anexo"></i>
                  <div class="anexo-detalhes">
                    <span class="anexo-nome-figma">{{ extraiNomeArquivoDaURLSemGuid(caminho)}}</span>
                    <span class="anexo-data">Adicionado em {{chamado.dtAbertura || 'Data não disponível'}}</span>
                  </div>
                </div>
                <div class="anexo-actions-figma">
                  <button type="button" class="btn-visualizar-anexo" (click)="visualizarArquivo(caminho)" title="Visualizar">
                    <i class="icon-eye"></i>
                    Visualizar
                  </button>
                  <button type="button" class="btn-icon-download" (click)="downloadDocument(caminho)" title="Baixar arquivo">
                    <i class="icon-download"></i>
                  </button>
                </div>
              </div>
                </div>
              </div>

              <!-- Envolvidos -->
              <div class="secao-envolvidos">
                <h2 class="section-title">Envolvidos</h2>
                <div class="envolvidos-lista-figma">
            <div *ngFor="let envolvido of this.envolvidos;" class="envolvido-item-figma">
              <div class="envolvido-avatar-figma">
                <div *ngIf="envolvido.foto" class="avatar-image-figma">
                  <img src="data:image/jpeg;base64,{{envolvido.foto}}" alt="Imagem do Envolvido">
                </div>
                <div *ngIf="!envolvido.foto" class="avatar-initials-figma">
                  <span>{{ envolvido.iniciais }}</span>
                </div>
                <span class="status-indicator-figma" [ngClass]="{'status-active': envolvido.status === 1}"></span>
              </div>
              <div class="envolvido-info-figma">
                <p class="envolvido-nome-figma notranslate" translate="no">{{envolvido.nome}}</p>
                <p class="envolvido-tipo-figma notranslate" translate="no">{{envolvido.ra ? envolvido.ra + ' · ' : ''}}{{envolvido.dsTipoPessoa}}</p>
                <p class="envolvido-categoria-figma notranslate" translate="no">{{chamado.dsCategoria}}</p>
              </div>
              <button 
                type="button" 
                class="btn_link btn-visualizar-envolvido"
                [routerLink]="['/perfil-aluno/', envolvido.codigoAluno]"
                aria-label="Visualizar perfil do envolvido">
                Visualizar
                  </button>
                </div>
              </div>
            </div>
            </div>
            
            <!-- Coluna Direita: Histórico do Chamado -->
            <div class="coluna-direita">
              <div class="historico-chamado-sidebar">
                <h2 class="section-title">Histórico do chamado</h2>
                
                <div class="anotacoes-container">
                  <h3 class="anotacoes-titulo">Anotações adicionadas</h3>
                  
                  <!-- Lista de Anotações/Histórico -->
                  <div class="anotacoes-lista" *ngIf="lstHistoricos && lstHistoricos.length > 0">
                    <div class="anotacao-card" *ngFor="let historico of lstHistoricos">
                      <div class="anotacao-content" *ngIf="historico.descricaoHistorico">
                        <p class="anotacao-texto">{{historico.descricaoHistorico}}</p>
                      </div>
                      <div class="anotacao-content" *ngIf="historico.caminhoArquivo">
                        <a href="javascript:void(0)" (click)="downloadDocument(historico.caminhoArquivo)">
                          {{ extraiNomeArquivoDaURLSemGuid(historico.caminhoArquivo) }}
                        </a>
                      </div>
                      <div class="anotacao-footer">
                        <span class="anotacao-meta">{{historico.data}} - {{historico.hora}} - {{historico.nomeUsuario}}</span>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Formulário para adicionar anotação -->
                  <div *ngIf="this.userLogado?.funcionalidades?.includes(9)" class="adicionar-anotacao">
                    <form [formGroup]="formCadastrarHistorico">
                      <div class="form-group-anotacao">
                        <textarea
                          rows="4"
                          id="dsHistoricoChamadoSidebar"
                          [(ngModel)]="dsHistoricoChamado"
                          formControlName="dsHistoricoChamado"
                          name="dsHistoricoChamadoSidebar"
                          class="form-textarea-anotacao"
                          placeholder="O máximo de caracteres permitidos são 500 e o mínimo são 10"
                          maxlength="500"
                          aria-label="Descrição do histórico"
                        ></textarea>
                      </div>
                      
                      <div class="anotacao-actions">
                        <div class="file-input-wrapper-anotacao">
                          <input
                            type="file"
                            id="arquivos"
                            name="arquivos"
                            accept=".jpg, .jpeg, .png, .mp3, .mp4, .pdf"
                            (change)="OnFileChange($event)"
                            #archivoInput
                            class="file-input"
                          />
                          <label for="arquivos" class="btn-anexar-arquivo">
                            <i class="icon-attachment"></i>
                            Anexar arquivo
                          </label>
                        </div>
                        
                        <button
                          type="button"
                          class="btn-salvar-anotacao"
                          (click)="onSalvarHistorico('sidebar')"
                          aria-label="Salvar anotação"
                        >
                          <i class="icon-save"></i> Salvar anotação
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Modal de Histórico Detalhado (movido para fora da seção principal) -->
  <div *ngIf="showModalDetalheEnvolvido" class="historico-chamado-container">
            <h2 class="section-title">Histórico do Chamado</h2>
            <h3 class="historico-subtitle">{{ this.nomeSelected }}</h3>
            
            <div class="historico-timeline">
              <div
                class="historico-item"
                *ngFor="let historico of this.lstHistoricosDetalheEnvolvido"
              >
                <div class="historico-content">
                  <div *ngIf="historico.descricaoHistorico !== ''" class="historico-text">
                    <p>{{ historico.descricaoHistorico }}</p>
                    <div *ngIf="historico.infoAdicional1 || historico.infoAdicional2" class="info-adicional">
                      <i *ngIf="historico.infoAdicional1">- {{historico.infoAdicional1}}</i>
                      <i *ngIf="historico.infoAdicional2">- {{historico.infoAdicional2}}</i>
                    </div>
                  </div>
                  
                  <div *ngIf="historico.caminhoArquivo !== ''" class="historico-anexo">
                    <img 
                      *ngIf="!historico.caminhoArquivo?.endsWith('.pdf') && !historico.caminhoArquivo?.includes('mp3') && !historico.caminhoArquivo?.includes('mp4')" 
                      [src]="historico.caminhoArquivo" 
                      alt="Anexo" 
                      class="historico-image"
                    />
                    <div 
                      *ngIf="historico.caminhoArquivo?.endsWith('.pdf') || historico.caminhoArquivo?.endsWith('.mp3') || historico.caminhoArquivo?.endsWith('.mp4')" 
                      class="historico-file"
                      (click)="downloadDocument(historico.caminhoArquivo)"
                    >
                      <i [ngClass]="{
                        'icon-pdf': historico.caminhoArquivo?.endsWith('.pdf'),
                        'icon-mp3': historico.caminhoArquivo?.endsWith('.mp3'),
                        'icon-mp4': historico.caminhoArquivo?.endsWith('.mp4')
                      }"></i>
                      <p>{{ extraiNomeArquivoDaURLSemGuid(historico.caminhoArquivo)}}</p>
                    </div>
                  </div>
                  
                  <div class="historico-footer">
                    <span class="historico-data">
                      {{ historico.data }} - {{ historico.hora }} - {{ historico.nomeUsuario }}
                    </span>
                    <button
                      type="button"
                      *ngIf="this.userLogado?.DadosUsuario![0].CodigoPerfil == 1477 || this.userLogado?.DadosUsuario![0].CodigoPerfil == 1634"
                      class="btn-add-info"
                      (click)="openModalAddInfo(historico.codigoHistorico)"
                      title="Adicionar informação"
                      aria-label="Adicionar informação adicional"
                    >
                      <i class="icon-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Formulário para adicionar histórico -->
            <div *ngIf="this.userLogado?.funcionalidades?.includes(9)" class="adicionar-historico">
              <form [formGroup]="formCadastrarHistoricoDetalhe">
                <div class="form-group">
                  <label for="dsHistoricoChamadoDetalhe" class="form-label">Adicionar ao Histórico</label>
                  <textarea
                    rows="4"
                    cols="50"
                    id="dsHistoricoChamadoDetalhe"
                    [(ngModel)]="dsHistoricoChamadoDetalhe"
                    formControlName="dsHistoricoChamado"
                    name="dsHistoricoChamadoDetalhe"
                    class="form-textarea"
                    placeholder="Digite aqui sua observação..."
                    aria-label="Descrição do histórico"
                  ></textarea>
                </div>

                <div class="historico-actions">
                  <div class="file-input-wrapper">
                    <input
                      type="file"
                      id="arquivos"
                      name="arquivos"
                      accept=".jpg, .jpeg, .png, .mp3, .mp4, .pdf"
                      (change)="OnFileChange($event)"
                      #archivoInput
                      class="file-input"
                    />
                    <label for="arquivos" class="btn_outline file-label">
                      <i class="icon-attachment"></i>
                      <span *ngIf="files.length === 0">Anexar arquivo</span>
                      <span *ngIf="files.length === 1">{{ extraiNomeArquivoDaURLSemGuid(files[0].nome) }}</span>
                      <span *ngIf="files.length > 1">{{ files.length }} arquivos</span>
                    </label>
                  </div>

                  <button
                    type="button"
                    class="btn_primary"
                    (click)="onSalvarHistorico('detalhe')"
                    aria-label="Salvar histórico"
                  >
                    <i class="icon-send"></i> Salvar anotação
                  </button>
                </div>
              </form>
            </div>
          </div>

</form>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>

<app-modal *ngIf="showModalArquivo && file as arquivoSelecionado">
  <app-visualizar-arquivo [arquivo]="arquivoSelecionado" (fechar)="FecharModalArquivo()"></app-visualizar-arquivo>
</app-modal>

<app-modal *ngIf="showModalAddInfoHistorico">
  <div class="container-conviva form-registro modal-envolvidos">
    <form [formGroup]="formAddInfoHistorico">

      <h1 class="titulo-page">Adição</h1>
      <p>Ao comentario abaixo</p>
      <div class="descricao-historico-add-info">
        <p >{{this.historico?.descricaoHistorico}}</p>
        <i *ngIf="this.historico?.infoAdicional1" class="info-adiconal">- {{historico?.infoAdicional1}}</i>
        <i *ngIf="this.historico?.infoAdicional2" class="info-adiconal">- {{historico?.infoAdicional2}}</i>

      </div>
      <p>Escreva um comentário abaixo.</p>
      <textarea
        rows="5"
        cols="50"
        formControlName="newInfoHistoric"
        name="newInfoHistoric"
        class="text-area-new-info"
        maxlength="500"
        minlength="10"
        placeholder="O máximo de caracteres permitidos são 500 e o mínimo são 10."
        (keyup)="OnChangeCountLetters()"
      ></textarea>
      <div class="qtde-caracteres">
        <p>Quantidade de caracteres :{{qtdeCaracteresDescricao}}</p>
      </div>
    </form>


    <div class="container-btns">
      <input type="button" (click)="closeModalAddInfo()" class="btn_outline" value="Cancelar"/>
      <input type="submit" (click)="saveNewInfoOnHistoric()" class="btn_outline" value="Salvar"/>
    </div>
  </div>
</app-modal>

<app-modal *ngIf="showModalConcluirChamado">
  <div class="container-conviva form-registro modal-envolvidos">
    <div>
      <h1 class="titulo-page">Concluir Chamado</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span >{{ this.descricaoConcluir }}</span>

    </div>
    <div class="container-btns">
      <input
        type="button"
        (click)="FecharModalConcluir()"
        class="btn_outline"
        value="Não"
      />
      <input
        type="button"
        (click)="ConcluirChamado()"
        class="btn_primary"
        value="Sim"
      />
    </div>
  </div>
</app-modal>

<!-- Modal de Exclusão -->
<app-modal *ngIf="showModalExcluirChamado">
  <div class="container-conviva form-registro modal-envolvidos">
    <div>
      <h1 class="titulo-page">Chamado</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span>{{this.descricaoExclusao}}</span>
    </div>
    <div class="container-btns">
      <input type="button" (click)="FecharModalExclusao()" class="btn_outline" value="Não"/>
      <input type="button" (click)="ExcluirChamado(this.chamadoARemover)" class="btn_primary" value="Sim" />
    </div>
  </div>
</app-modal>

<!-- Modal de Encaminhamento -->
<app-modal *ngIf="showModalEncaminhar">
  <div class="container-conviva form-registro modal-encaminhamento-figma">
    <div class="header-modal-encaminhamento">
      <h1 class="titulo-encaminhamento">Tipo de encaminhamento</h1>
      <p class="subtitulo-encaminhamento">Para continuar, selecione o tipo de encaminhamento desejado</p>
    </div>

    <!-- Opções de Encaminhamento -->
    <div class="encaminhamento-opcoes-figma">
      <div class="row">
            <div class="col-sm-4" *ngIf="this.userLogado?.funcionalidades?.includes(6)" >
              <button
                id="btnEncPisicologo"
                type="button"
                (click)="PrepararEncaminhamento('psicologo')"
                class="btn-encaminhamento {{this.cssBtnPsicologo}}">
                <img src="../../../assets/img/icons/btn-enc-psicologo.svg" alt="" />
                <span>Psicólogo</span>
              </button>
            </div>
            
            <div class="col-sm-4" *ngIf="this.userLogado?.funcionalidades?.includes(7)">
              <button
                id="btnEncPolicia"
                type="button"
                (click)="PrepararEncaminhamento('rede-protetiva')"
                class="btn-encaminhamento {{this.cssBtnPolicia}}">
                <img src="../../../assets/img/icons/btn-enc-rede-protetiva.svg" alt="" />
                <span>Rede Protetiva</span>
              </button>
            </div>
            
            <div class="col-sm-4" *ngIf="this.userLogado?.funcionalidades?.includes(8)">
              <button
                id="btnEncHospitalar"
                type="button"              
                (click)="PrepararEncaminhamento('rede-hospitalar')"
                class="btn-encaminhamento {{this.cssBtnHospital}}">
                <img src="../../../assets/img/icons/btn-rede-hospitalar.svg" alt="" />
                <span>Rede Hospitalar</span>
              </button> 
            </div>
          </div>
    </div>

    <!-- Área de Anexos (apenas para Rede Protetiva) -->
    <div class="encaminhamento-anexos" *ngIf="tipoEncaminhamento === 'rede-protetiva'" >
      <div class="container">
          <div class="titulo">Selecione o tipo *</div>

          <label class="opcao">
              <input type="radio" name="encaminhamento" value="1" (change)="onChangeTEP(1)">
              <span>Encaminhamento para Conselho Tutelar</span>
          </label>

          <label class="opcao">
              <input type="radio" name="encaminhamento" value="2" (change)="onChangeTEP(2)">
              <span>Encaminhamento para Assistência Social</span>
          </label>

          <label class="opcao">
              <input type="radio" name="encaminhamento" value="3" (change)="onChangeTEP(3)">
              <span>Encaminhamento para Saúde</span>
          </label>
      </div>
      <div id="dvAlerta" class="msg-alerta" aria-live="polite" style="display: none;">
        Seleção obrigatória.
      </div>

      <br/>
      <h3 class="anexos-titulo">Deseja incluir anexos no encaminhamento?</h3>
      
      <div class="lista-arquivos" *ngIf="filesEncaminhamento.length > 0">
        <div class="arquivo-item" *ngFor="let arquivo of filesEncaminhamento; let i = index">
          <div class="arquivo-info">
            <i class="fa fa-paperclip"></i>
            <span class="arquivo-nome">{{ extraiNomeArquivoDaURLSemGuid(arquivo.nome) }}</span>
          </div>
          <button class="btn-excluir-arquivo" (click)="removerArquivoEncaminhamento(i)" title="Excluir">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>

      

      <div class="adicionar-arquivo">
        <input
          type="file"
          id="arquivosEncaminhamento"
          name="arquivosEncaminhamento"
          accept=".jpg, .jpeg, .png, .mp3, .mp4, .pdf"
          (change)="onFileChangeEncaminhamento($event)"
          class="file-input-hidden"
        />
        <label for="arquivosEncaminhamento" class="btn_outline btn-anexar">
          <i class="icon-paperclip"></i>
          Anexar arquivo
        </label>
      </div>
    </div>
      
    <!-- Botões de Ação -->
    <div class="container-btns">
      <input 
        type="button" 
        (click)="fecharModalEncaminhar()" 
        class="btn_outline" 
        value="Cancelar"
      />
      <input 
        type="button" 
        (click)="solicitarConfirmacaoEncaminhamento()" 
        class="btn_primary" 
        value="Confirmar"
        [disabled]="!tipoEncaminhamento"
      />
    </div>
  </div>
</app-modal>

<!-- Modal de Selecão de Envolvido para Encaminhar -->
<app-modal *ngIf="showModalSelecionarEnvolvidoEncaminhamento">
  <div class="container-conviva form-registro modal-confirmar-encaminhamento">
    <div>
      <h1 class="titulo-page">Selecionar envolvido</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span>O encaminhamento será realizado somente para o envolvido  selecionado.</span>
    </div>
    <br />
    <div class="item-envolvido" *ngFor="let envolvido of turmasEnvolvidos; let i = index">
      <label class="opcao-container">
        <input type="radio" name="encaminhamento" [value]="envolvido.codigoEnvolvido" (change)="onChangeEnvolvido($event)">
        
        <div class="info-envolvido">
          <span class="identificacao notranslate" translate="no">{{envolvido.codigoEnvolvido}} - {{envolvido.nome}}</span>
          <span class="descricao notranslate" translate="no">{{envolvido.dsEnvolvido}}</span>
        </div>
      </label>
    </div>
    <br/>

    <div class="container-btns">
      <input
        type="button"
        (click)="fecharModalEncaminhar()"
        class="btn_outline"
        value="Cancelar"
      />
      <input
        type="button"
        (click)="SelecionarVitima()"
        class="btn_primary"
        value="Confirmar"
      />
    </div>
  </div>
</app-modal>


<!-- Modal de Confirmação de Encaminhamento -->
<app-modal *ngIf="showModalConfirmarEncaminhamento">
  <div class="container-conviva form-registro modal-confirmar-encaminhamento">
    <div>
      <h1 class="titulo-page">Confirmar encaminhamento</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span>{{ mensagemConfirmacaoEncaminhamento }}</span>
    </div>
    <div class="container-btns">
      <input
        type="button"
        (click)="fecharModalConfirmacaoEncaminhamento()"
        class="btn_outline"
        value="Cancelar"
      />
      <input
        type="button"
        (click)="confirmarEncaminhamento()"
        class="btn_primary"
        value="Confirmar"
      />
    </div>
  </div>
</app-modal>

<!-- Modal de Sucesso do Encaminhamento -->
<app-modal *ngIf="showModalSucessoEncaminhamento">
  <div class="container-conviva form-registro modal-sucesso-encaminhamento">
    <div class="icon-sucesso-container">
      <i class="icon-sucesso"></i>
    </div>
    <h1 class="titulo-sucesso">Encaminhamento realizado com sucesso</h1>
    <p class="mensagem-sucesso">{{ mensagemSucessoEncaminhamento }}</p>
    <div class="container-btns">
      <input
        type="button"
        (click)="fecharModalSucessoEncaminhamento()"
        class="btn_primary"
        value="OK"
      />
    </div>
  </div>
</app-modal>


<!-- Modal de Histórico de Status -->
<app-modal *ngIf="showModalHistoricoStatus">
  <div class="container-conviva form-registro modal-historico-status">
    <div class="header-modal-historico">
      <i class="icon-historico-status"></i>
      <div>
        <h1 class="titulo-page">Histórico de status</h1>
        <p class="subtitulo-modal">Acompanhe as mudanças de status deste chamado.</p>
      </div>
    </div>

    <div class="lista-status">
      <div class="status-item" *ngFor="let historico of historicosStatus; let i = index">
        <div class="status-info">
          <h3 class="status-titulo">Status {{ i + 1 }}</h3>
          <p class="status-descricao">{{ getStatusNome(historico.statusChamado) }}</p>
          <p class="status-descricao" *ngIf="historico.descricaoHistorico">{{ historico.descricaoHistorico }}</p>
          <p class="status-data">{{ historico.data }} {{ historico.hora }}</p>
        </div>
      </div>

      <div class="status-item status-vazio" *ngIf="historicosStatus.length === 0">
        <p>Nenhum histórico de status disponível.</p>
      </div>
    </div>

    <div class="container-btns">
      <input 
        type="button" 
        (click)="fecharModalHistoricoStatus()" 
        class="btn_primary" 
        value="Fechar"
      />
    </div>
  </div>
</app-modal>

<!-- Modal de Tipo de Agendamento -->
<app-modal *ngIf="showModalAgendamento">
  <div class="container-conviva form-registro modal-tipo-agendamento">
    <div class="header-modal-agendamento">
      <h1 class="titulo-page">Deseja agendar:</h1>
    </div>

    <div class="container-btns">
      <input 
        type="button" 
        (click)="navegarParaPrevencao()" 
        class="btn_outline" 
        value="Prevenção"
      />
      <input 
        type="button" 
        (click)="navegarParaAcolhimento()" 
        class="btn_primary" 
        value="Acolhimento"
      />
      <input 
        type="button" 
        (click)="fecharModalAgendamento()" 
        class="btn_terciario" 
        value="Fechar"
      />
    </div>
  </div>
</app-modal>
